/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Case_Id_LabelInputs */

const en_case_id_label = /** @type {(inputs: Case_Id_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ID: ${i?.id}`)
};

const pt_br2_case_id_label = /** @type {(inputs: Case_Id_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ID: ${i?.id}`)
};

/**
* | output |
* | --- |
* | "ID: {id}" |
*
* @param {Case_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_id_label = /** @type {((inputs: Case_Id_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Id_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_id_label(inputs)
	return pt_br2_case_id_label(inputs)
});